// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1JBSS","options":"AnswerScale_options__SoPK5","selected":"AnswerScale_selected__-8Hjn"};